import { render, staticRenderFns } from "./CategoryImage.vue?vue&type=template&id=0f1e8f9e&"
import script from "./CategoryImage.vue?vue&type=script&lang=js&"
export * from "./CategoryImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports